import { map } from 'lodash-es';
import { CameraConfigurations } from '../components/pages/routes/routePageSections/routeMap/vehicleTrackings/VideoRequestForm';

export const transformCameraConfigurations = (cameraConfigurations: CameraConfigurations[]): CameraConfigurations[] =>
  map(cameraConfigurations, cameraConfig => ({
    ...cameraConfig,
    isActive: true,
  }));
